export default __webpack_public_path__ + "static/oauth-e41f89fc9c986e2cd004178fda2b713a.webp";